(function () {
  'use strict';

  const menu = document.getElementById('vinga-fb-menu');

  if (!menu) return;

  const drawer = menu.querySelector('.vinga-fb-drawer');
  const overlay = menu.querySelector('.vinga-fb-overlay');
  const closeButtons = menu.querySelectorAll('[data-vinga-menu-close]');

  /*
   * ---------------------------------------------------------
   * OPEN MENU
   * ---------------------------------------------------------
   */

  function openMenu() {
  menu.classList.add('is-open');
  menu.setAttribute('aria-hidden', 'false');

  document.documentElement.classList.add('vinga-menu-open');
  document.body.classList.add('vinga-menu-open');

  /* Lock page scroll */
  document.documentElement.style.overflow = 'hidden';
  document.body.style.overflow = 'hidden';
  document.body.style.touchAction = 'none';

  /* Hide announcement bar */
  document.body.classList.add('vinga-hide-announcement');
}


  /*
   * ---------------------------------------------------------
   * CLOSE MENU
   * ---------------------------------------------------------
   */

  function closeMenu() {
  menu.classList.remove('is-open');
  menu.setAttribute('aria-hidden', 'true');

  document.documentElement.classList.remove('vinga-menu-open');
  document.body.classList.remove('vinga-menu-open');

  /* Restore page scrolling */
  document.documentElement.style.overflow = '';
  document.body.style.overflow = '';
  document.body.style.touchAction = '';

  /* Show announcement bar again */
  document.body.classList.remove('vinga-hide-announcement');
}


  /*
   * ---------------------------------------------------------
   * CLOSE BUTTON + OVERLAY
   * ---------------------------------------------------------
   */

  closeButtons.forEach(function (button) {
    button.addEventListener('click', function (event) {
      event.preventDefault();
      closeMenu();
    });
  });


  /*
   * ---------------------------------------------------------
   * ESC KEY
   * ---------------------------------------------------------
   */

  document.addEventListener('keydown', function (event) {

    if (event.key === 'Escape') {
      closeMenu();
    }

  });


  /*
   * ---------------------------------------------------------
   * FIND EXISTING MOBILE MENU BUTTON
   * ---------------------------------------------------------
   *
   * We try several common selectors because Impact
   * can have different menu button markup depending
   * on the theme version.
   */

  const menuSelectors = [
    '[aria-controls*="menu"]',
    '[aria-label*="Menu"]',
    '[aria-label*="menu"]',
    '.header__menu-button',
    '.header__icon-list button'
  ];


  /*
   * ---------------------------------------------------------
   * CONNECT BUTTON
   * ---------------------------------------------------------
   */

  function connectMenuButtons() {

    const buttons = new Set();

    menuSelectors.forEach(function (selector) {

      document.querySelectorAll(selector).forEach(function (button) {
        buttons.add(button);
      });

    });


    buttons.forEach(function (button) {

      /*
       * Don't connect our own buttons.
       */
      if (
        menu.contains(button) ||
        button.dataset.v360Connected === 'true'
      ) {
        return;
      }


      /*
       * Check whether this looks like the
       * Shopify mobile menu button.
       */
      const label =
        button.getAttribute('aria-label') ||
        button.getAttribute('title') ||
        '';

      const text =
        button.textContent ||
        '';

      const combined =
        (label + ' ' + text).toLowerCase();


      const looksLikeMenu =
        combined.includes('menu') ||
        combined.includes('navigation') ||
        button.querySelector('svg');


      if (!looksLikeMenu) return;


      button.dataset.v360Connected = 'true';


      button.addEventListener('click', function (event) {

        /*
         * Only hijack on mobile.
         */
        if (window.innerWidth >= 750) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        openMenu();

      }, true);

    });

  }


  /*
   * Connect immediately.
   */
  connectMenuButtons();


  /*
   * Shopify / Impact can dynamically rebuild
   * parts of the header, so reconnect if needed.
   */
  const observer = new MutationObserver(function () {
    connectMenuButtons();
  });


  observer.observe(document.body, {
    childList: true,
    subtree: true
  });


  /*
   * ---------------------------------------------------------
   * PUBLIC FUNCTIONS
   * ---------------------------------------------------------
   *
   * Useful later for the category navigation.
   */

  window.VingaMobileMenu = {
    open: openMenu,
    close: closeMenu
  };
    /* 
   * ---------------------------------------------------------
   * MOBILE CATEGORY NAVIGATION
   * ---------------------------------------------------------
   */

  const categoryButtons = menu.querySelectorAll(
    '.vinga-fb-category[data-category-index]'
  );

  const submenus = menu.querySelectorAll(
    '.vinga-fb-submenu[data-submenu-index]'
  );

  const backButtons = menu.querySelectorAll(
    '[data-back-menu]'
  );


  /* 
   * OPEN CATEGORY
   */

  categoryButtons.forEach(function (button) {

    button.addEventListener('click', function (event) {

      event.preventDefault();

      const index = button.getAttribute(
        'data-category-index'
      );

      const submenu = menu.querySelector(
        '.vinga-fb-submenu[data-submenu-index="' + index + '"]'
      );

      if (!submenu) return;

      submenu.classList.add('is-active');

    });

  });


  /* 
   * BACK TO MAIN MENU
   */

  backButtons.forEach(function (button) {

    button.addEventListener('click', function (event) {

      event.preventDefault();

      const submenu = button.closest(
        '.vinga-fb-submenu'
      );

      if (!submenu) return;

      submenu.classList.remove('is-active');

    });

  });

})();